import * as React from "react";

export const BackIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25">
    <path
      d="M20.2334 11.7981H8.0634L13.6534 6.2081L12.2334 4.7981L4.2334 12.7981L12.2334 20.7981L13.6434 19.3881L8.0634 13.7981H20.2334V11.7981Z"
      className="elm-fill-current elm-text-gray-500"
    />
  </svg>
);
